import { render, staticRenderFns } from "./detailPop.vue?vue&type=template&id=4eb45192&"
import script from "./detailPop.vue?vue&type=script&lang=js&"
export * from "./detailPop.vue?vue&type=script&lang=js&"
import style0 from "./detailPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb45192')) {
      api.createRecord('4eb45192', component.options)
    } else {
      api.reload('4eb45192', component.options)
    }
    module.hot.accept("./detailPop.vue?vue&type=template&id=4eb45192&", function () {
      api.rerender('4eb45192', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/detail-pop/detailPop.vue"
export default component.exports